$(document).ready(function () {
    $('#step_one_submit').prop("disabled", true);

    if ($('#type_of_employment').val() == 'part_time') {
        $('#hours_box').show();
        $('#week_avg_hours').prop("required", true);
    }

    $('#type_of_employment').change(function () {
        var selected = $(this).val();
        if (selected == 'part_time') {
            $('#hours_box').show();
            $('#week_avg_hours').prop("required", true);
        } else {
            $('#hours_box').hide();
            $('#week_avg_hours').val("");
            $('#week_avg_hours').prop("required", false);
        }
    });
    
    $('.other-allowance').change(function () {
        var selected = $(this).data('id');
        var selected_name = $(this).val();
        if (selected < 6) {
            selected = parseInt(selected)+1
            if (selected_name != '') {
                $('#row_'+selected).removeClass('hidden');
            } else {
                $('#row_'+selected).addClass('hidden');
                $('#allowance_value_'+selected).val('');
            }
        }
    });

    if ($('#has_bonus_commission').val() == '1') {
        $('#bonus_commission').removeClass('hidden');
    }

    $('#has_bonus_commission').change(function () {
        var selected = $(this).val();
        if (selected == '1') {
            $('#bonus_commission').removeClass('hidden');
            $('#has_this_year_bonus').prop("required", true);
        } else {
            $('#bonus_commission').addClass('hidden');
            $('#last_year_bonus').addClass('hidden');
            $('#expected_bonus').addClass('hidden');
            
            $('#has_this_year_bonus').val('');
            $('#has_this_year_bonus').prop('required', false);

            $('#this_year_bonus_input').val('');
            $('#this_year_bonus_input').prop("required", false);
            
            $('#last_year_bonus_input').val('');
            $('#last_year_bonus_input').prop("required", false);
            
            $('#expected_bonus_input').val('');
            $('#expected_bonus_input').prop("required", false);

            $('#has_this_year_bonus').prop("required", false);
            $('#has_last_year_bonus').val("");
        }
    });

    $('#has_this_year_bonus').change(function () {
        var selected = $(this).val();
        if (selected == '1') {
            $('#this_year_field').removeClass('hidden');
            $('#this_year_bonus_input').prop("required", true);
            $('#last_year_bonus').addClass('hidden');
            $('#last_year_bonus_input').val('');
            $('#last_year_bonus_input').prop("required", false);
            $('#expected_bonus_input').val('');
            $('#expected_bonus_input').prop("required", false);
            $('#expected_bonus').addClass('hidden');
            $('#has_last_year_bonus').prop("required", false);
            $('#has_last_year_bonus').val("");
        } else if (selected == '0') {
            $('#this_year_field').addClass('hidden');
            $('#this_year_bonus_input').val('');
            $('#this_year_bonus_input').prop("required", false);
            $('#last_year_bonus').removeClass('hidden');
            $('#last_year_field').addClass('hidden');
            $('#has_last_year_bonus').prop("required", true);
        } else {
            $('#this_year_field').addClass('hidden');
            $('#this_year_bonus_input').val('');
            $('#this_year_bonus_input').prop("required", false);
            $('#last_year_bonus').addClass('hidden');
            $('#has_last_year_bonus').prop("required", false);
            $('#has_last_year_bonus').val('');
            $('#expected_bonus').addClass('hidden');
            $('#expected_bonus_input').prop("required", false);
        }
    });

    $('#has_last_year_bonus').change(function () {
        var selected = $(this).val();
        if (selected == '1') {
            $('#last_year_field').removeClass('hidden');
            $('#last_year_bonus_input').prop("required", true);
            $('#expected_bonus').addClass('hidden');
            $('#expected_bonus_input').val('');
            $('#expected_bonus_input').prop("required", false);
        } else if (selected == '0') {
            $('#last_year_field').addClass('hidden');
            $('#last_year_bonus_input').val('');
            $('#last_year_bonus_input').prop("required", false);
            $('#expected_bonus').removeClass('hidden');
            $('#expected_bonus_input').prop("required", true);
        } else {
            $('#last_year_field').addClass('hidden');
            $('#last_year_bonus_input').val('');
            $('#last_year_bonus_input').prop("required", false);
            $('#expected_bonus').addClass('hidden');
            $('#expected_bonus_input').prop("required", false);
            $('#expected_bonus_input').val("");
        }
    });
});

function enableBtn() {
    $('#step_one_submit').prop("disabled", false);
}

$('#years_at_company').keyup( function(){
    if (this.value > 50) {
        this.value = '';
    } else if (this.value < 1) {
        this.value = '';
    }
});

var flattenPositions = function(positions) {
    let positionsFlat = [];

    positions.forEach(function(role) {
        positionsFlat.push(role.title);
        if (role.alt_title != null && role.alt_title.length > 0) {
            role.alt_title.forEach(function(item) {
                positionsFlat.push(item);
            });
        }
    });
    
    return positionsFlat;
}

var substringMatcher = function(strs) {
    return function findMatches(q, cb) {
        let matches = [];
        let suggestions = [];
        let substrRegex = new RegExp(q, 'i');

        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        $.each(strs, function(i, str) {
            if (substrRegex.test(str)) {
                matches.push(str);
            }
        });

        // Parse the map array for matches
        matches.forEach(function(query) {
            positions.forEach(function(role) {

                // Check if the title matches
                if (role.title.toLowerCase().indexOf(query.trim().toLowerCase()) != -1) {
                    suggestions.push(role.title);
                }
    
                if (role.alt_title != null && role.alt_title.length > 0) {
                    // Check if any alt_title matches and add the titlte
                    role.alt_title.forEach(function(alt_title) {
                        if (alt_title.toLowerCase().indexOf(query.trim().toLowerCase()) != -1) {
                            suggestions.push(role.title);
                        }
                    });
                }

            });
        });

        // Clean array of duplicate entries
        suggestions = suggestions.filter(function(elem, index, self) {
            return index == self.indexOf(elem);
        });

        cb(suggestions);
    };
};

if (typeof positions !== 'undefined') {
    $('#position .typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: 1
    },
    {
        name: 'positions',
        source: substringMatcher(flattenPositions(positions))
    });
}

$('.grid').masonry({
    // options...
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true
});

$.validator.addMethod("letters", function(value, element) {
    return this.optional(element) || /^[a-z\- _\/\(\)\s]+$/i.test(value);
}, "Letters only please");

$(window).on("scroll", function(e) {
    sidebarScroll();
});

$(function() {
    sidebarScroll();
});

function sidebarScroll() {
    var navBarHeight = $("nav.navbar").outerHeight();
    var availableHeight = $(window).height() - navBarHeight;;
    var currentScroll = getCurrentScroll();
    var footerTop = getFooterTop();

    var sidebarContent = $("#sidebar .sidebar-content");

    if (sidebarContent.length == 0) {
        return;
    }

    sidebarContent.css("top", "");

    var topPosition = (currentScroll + 40);
    var bottomPosition = topPosition + sidebarContent.outerHeight();
    var sidebarNaturalBottom = sidebarContent.position().top + sidebarContent.outerHeight();

    if ((currentScroll + availableHeight) <= sidebarNaturalBottom) {
        return;
    }

    if (bottomPosition > footerTop) {
        var difference = (bottomPosition - footerTop) + 60;
        topPosition -= difference;
        bottomPosition = topPosition + sidebarContent.outerHeight();
    }

    if (bottomPosition > (currentScroll + availableHeight)) {
        topPosition -= (bottomPosition - (currentScroll + availableHeight));
        topPosition -= 40;
        bottomPosition = topPosition + sidebarContent.outerHeight();
    }

    if (bottomPosition + navBarHeight > footerTop) {
        var difference = (bottomPosition - footerTop) + 140;
        topPosition -= difference;
        bottomPosition = topPosition + sidebarContent.outerHeight();
    }

    sidebarContent.css("top", topPosition + "px");
}

function getCurrentScroll() {
    return $(window).scrollTop();
}

function getFooterTop() {
    return $("#footer").position().top;
}